module.exports = __webpack_public_path__ + "static/media/k-share.e516ff82.svg";